import type { PublicationKind } from '../types/publication-kind';

export type PublicationCopy = {
  placeholder: string;
  guestPlaceholder: string;
  submitLabel: string;
  submitTitle: string;
  guestActionTitle: string;
  empty: string;
  loading: string;
  loadError: string;
  replyPlaceholder: (name: string) => string;
  reportTitle: string;
  created: string;
  replyCreated: string;
  createError: string;
  replyCreateError: string;
  deleteConfirm: (isReply: boolean) => string;
  deleted: (isReply: boolean) => string;
  deleteError: string;
  emptyContent: (isReply: boolean) => string;
  updated: (isReply: boolean) => string;
  updateError: string;
  unavailable: (isReply: boolean) => string;
  actionsLabel: (isReply: boolean) => string;
};

const commentCopy: PublicationCopy = {
  placeholder: 'Комментарий...',
  guestPlaceholder: 'Войдите в систему для комментирования...',
  submitLabel: 'Отправить',
  submitTitle: 'Отправить комментарий',
  guestActionTitle: 'Войдите в систему для комментирования',
  empty: 'Пока нет комментариев. Будьте первым!',
  loading: 'Загружаем комментарии...',
  loadError: 'Ошибка загрузки комментариев',
  replyPlaceholder: (name) => `Ответить на комментарий ${name}...`,
  reportTitle: 'Пожаловаться на комментарий',
  created: 'Комментарий добавлен',
  replyCreated: 'Комментарий добавлен',
  createError: 'Не удалось создать комментарий',
  replyCreateError: 'Не удалось создать комментарий',
  deleteConfirm: () => 'Вы уверены, что хотите удалить комментарий?',
  deleted: () => 'Комментарий удалён',
  deleteError: 'Не удалось удалить комментарий',
  emptyContent: () => 'Комментарий не может быть пустым',
  updated: () => 'Комментарий обновлён',
  updateError: 'Не удалось сохранить комментарий',
  unavailable: () => 'Содержимое комментария недоступно',
  actionsLabel: () => 'Действия с комментарием',
};

const reviewCopy: PublicationCopy = {
  placeholder: 'Напишите отзыв…',
  guestPlaceholder: 'Войдите, чтобы оставить отзыв',
  submitLabel: 'Отправить отзыв',
  submitTitle: 'Отправить отзыв',
  guestActionTitle: 'Войдите, чтобы оставить отзыв',
  empty: 'Пока нет отзывов. Будьте первым!',
  loading: 'Загружаем отзывы...',
  loadError: 'Ошибка загрузки отзывов',
  replyPlaceholder: (name) => `Ответить на отзыв ${name}…`,
  reportTitle: 'Пожаловаться на отзыв',
  created: 'Отзыв добавлен',
  replyCreated: 'Ответ добавлен',
  createError: 'Не удалось создать отзыв',
  replyCreateError: 'Не удалось создать ответ',
  deleteConfirm: (isReply) =>
    isReply ? 'Вы уверены, что хотите удалить ответ?' : 'Вы уверены, что хотите удалить отзыв?',
  deleted: (isReply) => (isReply ? 'Ответ удалён' : 'Отзыв удалён'),
  deleteError: 'Не удалось удалить',
  emptyContent: (isReply) =>
    isReply ? 'Ответ не может быть пустым' : 'Отзыв не может быть пустым',
  updated: (isReply) => (isReply ? 'Ответ обновлён' : 'Отзыв обновлён'),
  updateError: 'Не удалось сохранить',
  unavailable: (isReply) =>
    isReply ? 'Содержимое ответа недоступно' : 'Содержимое отзыва недоступно',
  actionsLabel: (isReply) => (isReply ? 'Действия с ответом' : 'Действия с отзывом'),
};

export function getPublicationCopy(kind: PublicationKind = 'comment'): PublicationCopy {
  return kind === 'review' ? reviewCopy : commentCopy;
}
